import { useEffect, useState, Component } from "react";
import "@/App.css";
import { AnimatePresence, MotionConfig, motion } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./sections/Navbar";
import Hero from "./sections/Hero";
import Marquee from "./components/Marquee";
import About from "./sections/About";
import Work from "./sections/Work";
import Impact from "./sections/Impact";
import GetInvolved from "./sections/GetInvolved";
import Gallery from "./sections/Gallery";
import Instagram from "./sections/Instagram";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";
import BackToTop from "./components/BackToTop";
import { LogoMark } from "./components/Logo";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-sand px-6 text-center">
          <div>
            <LogoMark size={72} className="mx-auto" />
            <p className="mt-6 font-script text-3xl text-[#0D4B56]">hope giver</p>
            <p className="mt-2 text-[#475569]">Something went wrong. Please refresh the page.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function Intro() {
  return (
    <motion.div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0D4B56]"
      initial={{ y: 0 }}
      animate={{ y: "-100%" }}
      transition={{ delay: 1.05, duration: 0.85, ease: [0.76, 0, 0.24, 1] }}
      data-testid="intro-overlay"
    >
      <motion.div
        className="flex flex-col items-center gap-3"
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.55, ease: "easeOut" }}
      >
        <LogoMark size={92} />
        <span className="font-script text-5xl font-bold text-[#F3E096]">hope giver</span>
      </motion.div>
    </motion.div>
  );
}

function Home() {
  const [introDone, setIntroDone] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduced) raf = requestAnimationFrame(loop);
    const t = setTimeout(() => setIntroDone(true), 1100);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.lenis = null;
      clearTimeout(t);
    };
  }, []);

  return (
    <div className="min-h-screen bg-sand font-body">
      <AnimatePresence>{!introDone && <Intro key="intro" />}</AnimatePresence>
      <Navbar introDone={introDone} />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Work />
        <Impact />
        <GetInvolved />
        <Gallery />
        <Instagram />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
      <Toaster richColors position="top-center" />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <MotionConfig reducedMotion="user">
        <Home />
      </MotionConfig>
    </ErrorBoundary>
  );
}

export default App;
